<label
  [style]="style"
  *ngIf="item.display_type == 'label'"
  [ngClass]="item.classes"
  [innerHTML]="text | translationFromString | safeHtml"
  (click)="onTemplateClick($event)"></label>
<h1
  [style]="style"
  *ngIf="item.display_type == 'h1'"
  [ngClass]="item.classes"
  [innerHTML]="text | translationFromString | safeHtml"
  (click)="onTemplateClick($event)"></h1>
<h2
  [style]="style"
  *ngIf="item.display_type == 'h2'"
  [ngClass]="item.classes"
  [innerHTML]="text | translationFromString | safeHtml"
  (click)="onTemplateClick($event)"></h2>
<h3
  [style]="style"
  *ngIf="item.display_type == 'h3'"
  [ngClass]="item.classes"
  [innerHTML]="text | translationFromString | safeHtml"
  (click)="onTemplateClick($event)"></h3>
<h4
  [style]="style"
  *ngIf="item.display_type == 'h4'"
  [ngClass]="item.classes"
  [innerHTML]="text | translationFromString | safeHtml"
  (click)="onTemplateClick($event)"></h4>
<h5
  [style]="style"
  *ngIf="item.display_type == 'h5'"
  [ngClass]="item.classes"
  [innerHTML]="text | translationFromString | safeHtml"
  (click)="onTemplateClick($event)"></h5>
<h6
  [style]="style"
  *ngIf="item.display_type == 'h6'"
  [ngClass]="item.classes"
  [innerHTML]="text | translationFromString | safeHtml"
  (click)="onTemplateClick($event)"></h6>
<p
  [style]="style"
  *ngIf="!item.display_type || item.display_type == 'p'"
  [ngClass]="item.classes"
  [innerHTML]="text | translationFromString | safeHtml"
  (click)="onTemplateClick($event)"></p>
